var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21172 6.39238C3.23867 6.12734 3.13535 5.8623 2.9377 5.68262L0.911719 3.23887V2.875H7.20977L12.0793 13.5529L16.3604 2.875H22.3664V3.23887L20.6324 4.90098C20.4842 5.01328 20.4078 5.20195 20.4393 5.38613V17.6049C20.4078 17.7891 20.4842 17.9777 20.6324 18.09L22.326 19.7521V20.116H13.8043V19.7521L15.5607 18.0496C15.7314 17.8789 15.7314 17.825 15.7314 17.5645V7.69062L10.8484 20.0846H10.1881L4.50996 7.69062V15.9967C4.46055 16.3471 4.57734 16.6975 4.82441 16.949L7.10645 19.7162V20.0801H0.637695V19.7207L2.91973 16.949C3.1623 16.6975 3.27461 16.3426 3.21172 15.9967V6.39238Z",
    fill: "#0A0909"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.98a3fc86.svg";
export { ForwardRef as ReactComponent };